<ul class="tab card no-pad no-shadow card-border">
  <li
    *ngFor="let tab of tabList"
    (click)="select($event)"
    [innerText]="tab.label | translate"
    [attr.id]="tab.id"
    class="tab-item typo-body-2-noquery">
  </li>
</ul>